import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';

import SingleButton from '../SingleButton';
import TabTexLabelCustomSpace from '../TabTexLabelCustomSpace';

export type CustomToggleSectionProps = {
  labelTitle: string;
  children: React.ReactNode;
  customShowInitState?: boolean;
};

const CustomToggleSection: React.FC<CustomToggleSectionProps> = ({
  children,
  labelTitle,
  customShowInitState = false,
}) => {
  const [show, setShow] = useState(customShowInitState);

  return (
    <>
      <TabTexLabelCustomSpace
        textContent={labelTitle}
        showCustomRightSpace={true}
        customRightSpace={
          <SingleButton
            newCustomButton
            startIcon={show ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            label={show ? 'OCULTAR' : 'VER MÁS'}
            variant="text"
            onClick={() => {
              setShow(prev => !prev);
            }}
          />
        }
      />

      {show && children}
    </>
  );
};

export default CustomToggleSection;
